import { Tag } from "@chakra-ui/react";
import { AcordoTipoContatoEnum } from "features/cobranca/typings";

interface TagStatusCobrancaPorProps {
  status: AcordoTipoContatoEnum | null | undefined;
}

export default function TagStatusCobrancaPor({
  status,
}: TagStatusCobrancaPorProps) {
  return (
    <Tag border="solid 1px black" rounded="16" bg="none">
      {status === AcordoTipoContatoEnum.Aplicativo
        ? "Aplicativo"
        : status === AcordoTipoContatoEnum.Email
        ? "E-mail"
        : "Ligação"}
    </Tag>
  );
}
